import { Franchise } from './Franchise'
import { Motto } from './Motto'
import { LoadApp } from './LoadApp'

export const Component = { Motto, Franchise, LoadApp }
